import React, { useState } from 'react';
import { observer } from 'mobx-react';

import documentIcon from 'core/assets/svg/ic-document-24px.svg';
import { useStore } from 'core/store';
import { OfferDocumentModal } from 'offer/components/offer-document-upload';
import useStyles from './supporting-documents.styles';

// Opens today's supporting documents modal. Disabled until the offer has a pre-bind ID, which the
// documents are stored against.
const SupportingDocuments = () => {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);
  const { offer: store } = useStore();

  // Same rule as the classic header's SupportingDocumentsButton: a recalculation keeps the card in place.
  if (store.loading && !store.recalculatingPrice) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className={classes.card}
        onClick={() => setModalOpen(true)}
        disabled={!store.offer?.webUserId}
      >
        <img src={documentIcon} alt="" className={classes.icon} />
        <span className={classes.text}>
          <span className={classes.title}>Supporting documents</span>
          <span className={classes.count}>{store.documentCountDisplay}</span>
        </span>
      </button>
      <OfferDocumentModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default observer(SupportingDocuments);
